export default (() => {
  if (typeof window === 'undefined') return;
  (function (window, document) {
    function LogTracker(host, project, logstore) {
      this.uri_ =
        'https://' +
        project +
        '.' +
        host +
        '/logstores/' +
        logstore +
        '/track.gif?APIVersion=0.6.0';
      this.params_ = [];
    }
    LogTracker.prototype = {
      push: function (key, value) {
        if (!key || !value) {
          return;
        }
        this.params_.push(key);
        this.params_.push(value);
      },
      logger: function () {
        var url = this.uri_;
        var k = 0;
        while (this.params_.length > 0) {
          if (k % 2 == 0) {
            url += '&' + encodeURIComponent(this.params_.shift());
          } else {
            url += '=' + encodeURIComponent(this.params_.shift());
          }
          ++k;
        }
        var img = document.createElement('img');
        img.height = 1;
        img.width = 1;
        img.src = url;
      },
    };
    window.Tracker = LogTracker;
  })(window, document);
})();
